/**
 * @file 订单成功态
 */
import { ReactNode } from 'react';
import { Row } from '@/components';
import { useFm } from '@web3/base-hooks';
import { ShareIcon } from '@bfe/moly-icons';
import { shortAddress } from '@/utils/common';
import { useToast } from '@web3/base-hooks';
import { getAddress } from '@/utils/common';
import copy from 'copy-to-clipboard';
import styles from './index.module.scss';
import SuccessIcon from '@/assets/images/stake-success.svg';

interface Props {
  children: ReactNode;
  data?: {
    label: string;
    address: string;
    useHexPrefix?: boolean;
  }[];
}

export const OrderResultSuccess = (props: Props) => {
  const { children, data } = props;
  const fm = useFm();
  const { toastSuccess } = useToast();

  const onCopy = (v: string) => {
    copy(v);
    toastSuccess(fm('copySuccess'));
  };

  return (
    <div className={styles.container}>
      <div className={styles.status}>
        <SuccessIcon className={styles.processIcon} />
        <div className={styles.title}>{fm('success')}</div>
        {children}
      </div>
      {data?.map((item, index) => {
        const { label, address, useHexPrefix = true } = item;
        return (
          address && (
            <Row
              label={label}
              className={index > 0 ? styles.mt12 : ''}
              key={index}
              value={
                <div className={styles.row} key={address}>
                  <div>{shortAddress(address, '...', useHexPrefix)}</div>
                  <ShareIcon
                    className={styles.shareIcon}
                    onClick={() => {
                      onCopy(useHexPrefix ? getAddress(address) : address);
                    }}
                  />
                </div>
              }
            />
          )
        );
      })}
    </div>
  );
};
